import script from "./RoomObjectDefaultsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomObjectDefaultsEditor.vue?vue&type=script&setup=true&lang=js"

import "./RoomObjectDefaultsEditor.vue?vue&type=style&index=0&id=9f7398d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f7398d2"]])

export default __exports__